const CellCondensed = ({ children }) => {
  return (
    <span
      className="badge text-left font-weight-light py-1"
      style={{ whiteSpace: "normal" }}
    >
      {children}
    </span>
  );
};

export default CellCondensed;
